import {Injectable} from '@angular/core';
import {notificationStore} from './notifications.store';
import {GeneralAnnouncementDto, UserNotificationDto} from '../../../types/notifications.type';
import {setProps} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class NotificationsManager {
  public setLoading(value: boolean) {
    notificationStore.update(setProps({isLoading: value}));
  }

  public setPersonalNotifications(value: UserNotificationDto[]) {
    notificationStore.update(setProps({personalNotifications: value}));
  }

  public setGeneralAnnouncements(value: GeneralAnnouncementDto[]) {
    notificationStore.update(setProps({generalAnnouncements: value}));
  }

  public reset() {
    notificationStore.reset();
  }
}
